import { ROLES } from "app/constants";
import useAccess from "features/profile/useAccess";
import { useEffect, useState } from "react";
import { getRefundEligibleCount } from "./bookingApi";

export default function useRefundEligibleCount() {
  const [count, setCount] = useState(0);
  const { hasRoles } = useAccess();

  async function loadCount() {
    if (hasRoles(ROLES.PARTNER)) {
      return;
    }
    const { success, data } = await getRefundEligibleCount();
    if (success) {
      setCount(data?.count || 0);
    }
  }

  useEffect(() => {
    loadCount();
  }, []);

  return count;
}
